import React from 'react';

import Tooltip from '@material-ui/core/Tooltip';

import { ICON_NAMES, MaterialDesignIcon } from '../util/material-design-icons';

type InputProps = {
  twilioTrustHubBundleStatus?: string | null;
  Organizations: TeamEngineAccountOrg[];
};
export const CarrierRegistrationIcon = ({
  twilioTrustHubBundleStatus,
  Organizations,
}: InputProps) => {
  const isBundleRegistered = twilioTrustHubBundleStatus === 'APPROVED';
  const organizationCampaignsNotVerified = Organizations.filter(
    (organization) => organization.twilioCampaignRegistrationStatus !== 'VERIFIED',
  );

  if (!isBundleRegistered || organizationCampaignsNotVerified.length) {
    const bundleTooltip = !isBundleRegistered
      ? `Bundle registration status: ${twilioTrustHubBundleStatus ?? 'Not submitted'}\n`
      : '';

    const campaignsTooltipArray = organizationCampaignsNotVerified.map(
      (organization) =>
        `${organization.name}'s campaign registration status: ${
          organization.twilioCampaignRegistrationStatus ?? 'Not submitted'
        }`,
    );
    const campaignsTooltipArrayToDisplay =
      campaignsTooltipArray.length > 3
        ? campaignsTooltipArray.slice(0, 3).concat('More failed organizations...')
        : campaignsTooltipArray;
    const combinedToolTip = `${bundleTooltip} ${
      campaignsTooltipArrayToDisplay.length ? campaignsTooltipArrayToDisplay.join('\n') : ''
    }`;

    return (
      <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{combinedToolTip}</div>}>
        <MaterialDesignIcon iconName={ICON_NAMES.CANCEL} color="error" />
      </Tooltip>
    );
  }

  return <MaterialDesignIcon iconName={ICON_NAMES.CHECK_CIRCLE} color="success" />;
};
